// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__1tsdm","Div":"CustomFadeBox_Div__2INVN","LargeDiv":"CustomFadeBox_LargeDiv__3r-Q_"};